import template from './index.html.twig';

Shopware.Component.register('sw-cms-preview-moorl-interactive-slider', {
    template,
});
